import { Suspense } from 'react'
import {
  Navigate,
  Route,
  RouterProvider,
  createBrowserRouter,
  createRoutesFromElements,
} from 'react-router-dom'

import ForgotPassword from 'src/pages/auth/forgot-password'
import ResetPassword from 'src/pages/auth/reset-password'
import SignUpScreen from 'src/pages/auth/sign-up-screen'
import SignInEmailScreen from 'src/pages/auth/sign-in-email-screen'
import SignInScreen from 'src/pages/auth/sign-in-screen'
import AcceptAccountOwnershipScreen from 'src/pages/account/accept-account-ownership'
import AcceptUserInviteScreen from 'src/pages/account/accept-user-invite'
import SingupFinishScreen from 'src/pages/auth/sign-up-finish-screen'
import SignUpEmailVerifyScreen from 'src/pages/auth/sign-up-email-verify-screen'
import SignInEmailVerifyScreen from 'src/pages/auth/sing-in-verify-email-screen'
import ForgotPasswordVerifyScreen from 'src/pages/auth/forgot-password-verify'
import ProfileSuspended from 'src/pages/profile-suspended'
import AccountsAllScreen from 'src/pages/account/accounts-all-screen'
import AdminRoutesScreen from 'src/pages/admin-routes'
import ChangesLogScreen from 'src/pages/changes-log'
import EmailLogScreen from 'src/pages/email-log'
import ErrorLogScreen from 'src/pages/error-log'
import ImpactTypesScreen from 'src/pages/impacts-types'
import ImpactPeriodsScreen from 'src/pages/impact-periods'
import AddLibraryImpactScreen from 'src/pages/impacts-library/add-library-impact'
import EditLibraryImpactScreen from 'src/pages/impacts-library/edit-library-impact'
import ImpactsLibraryScreen from 'src/pages/impacts-library/library-impacts-screen'
import QuantityTypesScreen from 'src/pages/quantity-types'
import UnSdgScreen from 'src/pages/un-sdg'
import UsersScreen from 'src/pages/users'
import UserSessionsScreen from 'src/pages/user-sessions'
import AccountsScreen from 'src/pages/account/accounts-screen'
import AddAccountScreen from 'src/pages/account/add-account'
import UserProfileScreen from 'src/pages/user-profile'
import DashboardScreen from 'src/pages/dashboard/dashboard-screen'
import AddImpactScreen from 'src/pages/impacts/add-impact'
import ImpactsScreen from 'src/pages/impacts/impacts-screen'
import JourneysScreen from 'src/pages/journeys/journeys-screen'
import ProductQRCodeScreen from 'src/pages/products/product-qr-code'
import AddProductScreen from 'src/pages/products/add-product'
import EditProductScreen from 'src/pages/products/edit-product'
import ScanHistoryScreen from 'src/pages/scans/scan-history'
import EditImpactScreen from 'src/pages/impacts/edit-impact'
import AddJourneyScreen from 'src/pages/journeys/add-journey'
import EditJourneyScreen from 'src/pages/journeys/edit-journey'
import ProductsScreen from 'src/pages/products/products-screen'
import AddStepScreen from 'src/pages/steps/add-step'
import EditStepScreen from 'src/pages/steps/edit-step'
import StepsScreen from 'src/pages/steps/steps-screen'
import EditAccountScreen from 'src/pages/account/edit-account'
import AccountSupportScreen from 'src/pages/account-support'
import ProductsAllScreen from 'src/pages/products/products-all-screen'
import AccountSuspended from 'src/pages/account-suspended'
import ProductsViewsScreen from 'src/pages/dashboard/products-views'
import LanguageTranslationsScreen from 'src/pages/languages/language-translations-screen'
import ApproveStepAccountConnectionScreen from 'src/pages/steps/approve-account-connection'
import SignIn2FAVerifyScreen from 'src/pages/auth/sign-in-2fa-verify'
import HealthCheckInternalScreen from 'src/pages/third-party-api/internal'
import HealthCheckExternalScreen from 'src/pages/third-party-api/external'
import ScannerScanCreateScreen from 'src/pages/scans/scan-create'
import LanguagesScreen from 'src/pages/languages/languages-screen'
import ScannerCameraScanCreateScreen from 'src/pages/scans/scan-camera-create'
import ScannerScanDraftsScreen from 'src/pages/scans/scan-draft'
import TransactionLogScreen from 'src/pages/transaction-log'
import WelcomeScreen from 'src/pages/dashboard/welcome-screen'
import ImpactsLikesScreen from 'src/pages/dashboard/impacts-likes'
import AccountIndustriesScreen from 'src/pages/account-industries'
import MediaListScreen from 'src/pages/media'
import AppSettingsScreen from 'src/pages/app-settings'
import QuantityTypeCategoriesScreen from 'src/pages/quantity-type-categories'
import SubscriptionPricesScreen from 'src/pages/subscription-prices'
import { CronJobsScreen } from 'src/pages/cron-jobs'
import { RedirectURLs } from 'src/pages/redirect-urls'
import LoginTypesScreen from 'src/pages/login-types'
import RatingSettingsScreen from 'src/pages/rating-settings'
import Maintenance from 'src/pages/maintenance'

import { RouterWrapper } from 'src/providers/router-wrapper'
import { SharedLayout, GuestLayout } from '../layouts'

import PrivateRoute from '../private-route'
import PrivateAdminRoute from '../private-admin-route'
import AccountRolesRoute from '../account-roles-route'

import { ROUTES } from 'src/constants'
import { NavBarAccountData, NavBarData, NavBarConsumerData } from '../navbar/navbar-data'

import { EAccountRoles } from 'src/types'
import { DefaultRedirect } from '../default-redirect'
import { InviteFriendRedirect } from '../invite-friend-redirect'
import WhiteLabelPartnersScreen from 'src/pages/white-label-partners'
import PrivateCustomerRoute from '../private-customer-route'
import UserDashboardScreen from 'src/pages/consumer-user/dashboard'
import TraicyChatbotScreen from 'src/pages/consumer-user/traicy-chatbot'
import InviteFriendsScreen from 'src/pages/consumer-user/invite-friends'
import ScanToEarnScreen from 'src/pages/consumer-user/scan-to-earn'
import ConsumerScanHistoryScreen from 'src/pages/consumer-user/scan-history'
import RewardPointsScreen from 'src/pages/reward-points'
import ScanToEarnManagementScreen from 'src/pages/scan-to-earn-management'
import DeclineReasonsScreen from 'src/pages/decline-reasons'
import ChallengesScreen from 'src/pages/challenges'
import ConsumerChallengesScreen from 'src/pages/consumer-user/challenges'
import AdminToolsScreen from 'src/pages/admin-tools'
import ApprovalFeedbacksScreen from 'src/pages/approval-feedbacks'

const adminRoles = [EAccountRoles.admin, EAccountRoles.owner]
const userRoles = [
  // EAccountRoles.user,
  EAccountRoles.admin,
  EAccountRoles.owner,
]
const scannerRoles = Object.values(EAccountRoles)

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route element={<RouterWrapper />}>
      <Route
        path={`/${ROUTES.INVITE_FRIEND_REDIRECT}/${ROUTES.INVITE_FRIEND_REFERRAL_ID}`}
        element={<InviteFriendRedirect />}
      />
      <Route index path="*" element={<DefaultRedirect />} />
      <Route path={ROUTES.MAINTENANCE} element={<Maintenance />} />

      <Route path={`/${ROUTES.USER}/*`} element={<SharedLayout navbarData={NavBarConsumerData} />}>
        <Route element={<PrivateCustomerRoute />}>
          <Route
            path="*"
            element={<Navigate to={`/${ROUTES.USER}/${ROUTES.USER_DASHBOARD}`} replace />}
          />
          <Route index path={ROUTES.USER_DASHBOARD} element={<UserDashboardScreen />} />
          <Route path={ROUTES.SCAN_TO_EARN} element={<ScanToEarnScreen />} />
          <Route path={ROUTES.SCAN_HISTORY} element={<ConsumerScanHistoryScreen />} />
          <Route path={ROUTES.TRAICY_CHATBOT} element={<TraicyChatbotScreen />} />
          <Route path={ROUTES.CHALLENGES_USER} element={<ConsumerChallengesScreen />} />
          <Route path={ROUTES.INVITE_FRIENDS} element={<InviteFriendsScreen />} />
          {/* <Route path={ROUTES.SUPPORT} element={<SupportScreen />} /> */}
        </Route>
      </Route>

      <Route path="/*" element={<SharedLayout navbarData={NavBarData} />}>
        <Route path="*" element={<Navigate to={`/${ROUTES.ACCOUNTS}`} replace />} />
        <Route element={<PrivateRoute />}>
          <Route index path={ROUTES.ACCOUNTS} element={<AccountsScreen />} />
          <Route path={ROUTES.ACCOUNTS_ADD} element={<AddAccountScreen />} />
          <Route path={ROUTES.PROFILE} element={<UserProfileScreen />} />
          <Route path={ROUTES.SCANS_CREATE} element={<ScannerScanCreateScreen />} />
          <Route path={ROUTES.SCANS_DRAFTS} element={<ScannerScanDraftsScreen />} />
          <Route path={ROUTES.SCANS_CAMERA_CREATE} element={<ScannerCameraScanCreateScreen />} />
          <Route path={ROUTES.SCANS_DASHBOARD} element={<ScannerCameraScanCreateScreen />} />
          <Route path={ROUTES.SCAN_HISTORY} element={<ScanHistoryScreen />} />
        </Route>

        <Route element={<PrivateAdminRoute />}>
          <Route index path={ROUTES.ACCOUNTS_ALL} element={<AccountsAllScreen />} />
          <Route index path={ROUTES.PRODUCTS_ALL} element={<ProductsAllScreen />} />
          <Route path={ROUTES.USERS} element={<UsersScreen />} />
          <Route path={ROUTES.IMPACTS_LIBRARY} element={<ImpactsLibraryScreen />} />
          <Route path={ROUTES.IMPACTS_LIBRARY_ADD} element={<AddLibraryImpactScreen />} />
          <Route path={ROUTES.IMPACTS_LIBRARY_ID} element={<EditLibraryImpactScreen />} />
          <Route path={ROUTES.ADMIN_ROUTES} element={<AdminRoutesScreen />} />
          <Route path={ROUTES.QUANTITY_TYPES} element={<QuantityTypesScreen />} />
          <Route
            path={ROUTES.QUANTITY_TYPES_CATEGORIES}
            element={<QuantityTypeCategoriesScreen />}
          />
          <Route path={ROUTES.UN_SDG} element={<UnSdgScreen />} />
          <Route path={ROUTES.IMPACT_TYPES} element={<ImpactTypesScreen />} />
          <Route path={ROUTES.ACCOUNT_INDUSTRIES} element={<AccountIndustriesScreen />} />
          <Route path={ROUTES.SUBSCRIPTION_PRICES} element={<SubscriptionPricesScreen />} />
          <Route path={ROUTES.REWARD_POINTS} element={<RewardPointsScreen />} />
          <Route path={ROUTES.CHALLENGES} element={<ChallengesScreen />} />
          <Route path={ROUTES.DECLINE_REASONS} element={<DeclineReasonsScreen />} />
          <Route path={ROUTES.APPROVAL_FEEDBACKS} element={<ApprovalFeedbacksScreen />} />
          <Route path={ROUTES.SCAN_TO_EARN_MANAGEMENT} element={<ScanToEarnManagementScreen />} />
          <Route path={ROUTES.SETTINGS} element={<AppSettingsScreen />} />
          <Route path={ROUTES.IMPACT_PERIODS} element={<ImpactPeriodsScreen />} />

          <Route path={ROUTES.CHANGES} element={<ChangesLogScreen />} />
          <Route path={ROUTES.ERROR_LOGS} element={<ErrorLogScreen />} />
          <Route path={ROUTES.EMAIL_LOGS} element={<EmailLogScreen />} />
          <Route path={ROUTES.TRANSACTION_LOGS} element={<TransactionLogScreen />} />
          <Route path={ROUTES.USER_SESSIONS} element={<UserSessionsScreen />} />
          <Route path={ROUTES.LANGAUGE_TRANSLATIONS} element={<LanguageTranslationsScreen />} />
          <Route path={ROUTES.LOGIN_TYPES} element={<LoginTypesScreen />} />
          <Route path={ROUTES.WHITE_LABEL_PARTNERS} element={<WhiteLabelPartnersScreen />} />
          <Route path={ROUTES.LANGUAGES} element={<LanguagesScreen />} />
          <Route path={ROUTES.HEALTH_CHECK} element={<HealthCheckInternalScreen />} />
          <Route path={ROUTES.MEDIA_VAULT} element={<MediaListScreen />} />
          <Route path={ROUTES.REDIRECT_URLS} element={<RedirectURLs />} />
          <Route path={ROUTES.CRON_JOBS} element={<CronJobsScreen />} />
          <Route path={ROUTES.RATING_SETTINGS} element={<RatingSettingsScreen />} />
          <Route path={ROUTES.ADMIN_TOOLS} element={<AdminToolsScreen />} />
        </Route>

        <Route path={ROUTES.SUSPENDED} element={<ProfileSuspended />} />
      </Route>

      <Route
        path={`/${ROUTES.ACCOUNTS_ID}/*`}
        element={<SharedLayout navbarData={NavBarAccountData} />}
      >
        <Route path="*" element={<Navigate to={`/${ROUTES.ACCOUNTS}`} replace />} />
        <Route element={<PrivateRoute />}>
          <Route element={<AccountRolesRoute roles={adminRoles} />}>
            <Route path={ROUTES.ACCOUNT} element={<EditAccountScreen />} />
            <Route path={ROUTES.ACCOUNT_SUPPORT} element={<AccountSupportScreen />} />
          </Route>

          <Route element={<AccountRolesRoute roles={userRoles} />}>
            <Route index path={ROUTES.DASHBOARD} element={<DashboardScreen />} />
            <Route index path={ROUTES.DASHBOARD_WELCOME} element={<WelcomeScreen />} />
            <Route path={ROUTES.PRODUCTS_VIEWS} element={<ProductsViewsScreen />} />
            <Route path={ROUTES.IMPACTS_LIKES} element={<ImpactsLikesScreen />} />

            <Route path={ROUTES.PRODUCTS} element={<ProductsScreen />} />
            <Route path={ROUTES.PRODUCTS_ID} element={<EditProductScreen />} />
            <Route path={ROUTES.PRODUCTS_ADD} element={<AddProductScreen />} />
            <Route path={ROUTES.PRODUCTS_ID_QR} element={<ProductQRCodeScreen />} />
            <Route path={ROUTES.PRODUCTS_ID_HISTORY} element={<ProductQRCodeScreen />} />

            <Route path={ROUTES.STEPS} element={<StepsScreen />} />
            <Route path={ROUTES.STEPS_ID} element={<EditStepScreen />} />
            <Route path={ROUTES.STEPS_ADD} element={<AddStepScreen />} />

            <Route path={ROUTES.JOURNEYS} element={<JourneysScreen />} />
            <Route path={ROUTES.JOURNEYS_ID} element={<EditJourneyScreen />} />
            <Route path={ROUTES.JOURNEYS_ADD} element={<AddJourneyScreen />} />

            <Route path={ROUTES.IMPACTS} element={<ImpactsScreen />} />
            <Route path={ROUTES.IMPACTS_ID} element={<EditImpactScreen />} />
            <Route path={ROUTES.IMPACTS_ADD} element={<AddImpactScreen />} />
          </Route>

          <Route element={<AccountRolesRoute roles={scannerRoles} />}>
            <Route path={ROUTES.SCANS_DASHBOARD} element={<ScannerCameraScanCreateScreen />} />
            <Route path={ROUTES.SCANS_CREATE} element={<ScannerScanCreateScreen />} />
            <Route path={ROUTES.SCANS_DRAFTS} element={<ScannerScanDraftsScreen />} />

            <Route path={ROUTES.SCANS_CAMERA_CREATE} element={<ScannerCameraScanCreateScreen />} />
          </Route>

          <Route path={ROUTES.ACCOUNT_SUSPENDED} element={<AccountSuspended />} />
          <Route path={ROUTES.PROFILE} element={<UserProfileScreen />} />
          <Route path={ROUTES.SCAN_HISTORY} element={<ScanHistoryScreen />} />
        </Route>
      </Route>

      <Route path={ROUTES.LOGIN_TOKEN} element={<SignInScreen />} />
      <Route path={ROUTES.LOGIN} element={<SignInScreen />} />
      <Route path={ROUTES.LOGIN_EMAIL} element={<SignInEmailScreen />} />
      <Route path={ROUTES.LOGIN_EMAIL_VERIFY} element={<SignInEmailVerifyScreen />} />
      <Route path={ROUTES.LOGIN_2FA_VERIFY} element={<SignIn2FAVerifyScreen />} />
      <Route path={ROUTES.REGISTER} element={<SignUpScreen />} />
      <Route path={ROUTES.REGISTER_TOKEN} element={<SignUpScreen />} />
      <Route path={ROUTES.REGISTER_EMAIL} element={<SignUpEmailVerifyScreen />} />
      <Route path={ROUTES.REGISTER_FINISH} element={<SingupFinishScreen />} />
      <Route path={ROUTES.REGISTER_FINISH_TOKEN} element={<SingupFinishScreen />} />
      <Route path={ROUTES.FORGOT_PASSWORD} element={<ForgotPassword />} />
      <Route path={ROUTES.FORGOT_PASSWORD_VERIFY} element={<ForgotPasswordVerifyScreen />} />
      <Route path={ROUTES.RESET_PASSWORD} element={<ResetPassword />} />
      <Route path={ROUTES.ACCEPT_ACCOUNT_INVITE} element={<AcceptUserInviteScreen />} />
      <Route path={ROUTES.ACCEPT_ACCOUNT_OWNERSHIP} element={<AcceptAccountOwnershipScreen />} />
      <Route
        path={ROUTES.APPROVE_STEP_ACCOUNT_CONNECTION}
        element={<ApproveStepAccountConnectionScreen />}
      />

      <Route element={<PrivateAdminRoute />}>
        <Route path={ROUTES.HEALTH_CHECK_EXTERNAL} element={<HealthCheckExternalScreen />} />
      </Route>
    </Route>,
  ),
)

const Root = () => {
  return (
    <GuestLayout>
      <Suspense fallback={null}>
        <RouterProvider router={router} />
      </Suspense>
    </GuestLayout>
  )
}

export default Root
